<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col>
                <h3>EPF Settings</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-col
                cols="6"
                md="3"
                xl="2"
              />
              <v-col
                cols="3"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="settingsYearFilter"
                  clearable
                  :items="settingsYears"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-epf-settings-dialog-copy
                  v-if="$hasPermissionTo(['copy epf'])"
                  :available-years="settingsYears"
                  @created="handleEpfSettingsCopied"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['create epf'])"
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-epf-settings-dialog-create
                  @created="loadEpfSettings"
                />
              </v-col>
            </v-row>
          </v-card-actions>
          <v-data-table
            :headers="settingsHeaders"
            :loading="settingsLoading"
            :items="filteredEpfSetting"
          >
            <template v-slot:item.total_gross_without_additional_remuneration="{ item }">
              <div>
                <span>
                  {{ item.total_gross_without_additional_remuneration!=null ? currencyFormatting(item.total_gross_without_additional_remuneration) : "" }}
                </span>
              </div>
            </template>
            <template v-slot:item.total_gross_with_additional_remuneration="{ item }">
              <div>
                <span>
                  {{ item.total_gross_with_additional_remuneration!=null ? currencyFormatting(item.total_gross_with_additional_remuneration) : "" }}
                </span>
              </div>
            </template>
            <template v-slot:item.employee_rate="{ item }">
              <div>
                <span>
                  {{ item.employee_rate!=null ? decimalFormating(item.employee_rate) : "" }}
                </span>
              </div>
            </template>
            <template v-slot:item.employer_rate="{ item }">
              <div>
                <span>
                  {{ item.employer_rate!=null ? decimalFormating(item.employer_rate) : "" }}
                </span>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <payroll-setup-epf-settings-dialog-edit
                v-if="$hasPermissionTo(['update epf'])"
                :epfsetting="item"
                @updated="loadEpfSettings"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-10">
          <v-card-actions>
            <v-row>
              <v-col>
                <h3>EPF Rates</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-spacer />
              <v-col
                cols="6"
                md="3"
                xl="2"
              />
              <v-col
                cols="3"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="yearFilter"
                  clearable
                  :items="years"
                  label="Year Filter"
                  placeholder="Filter by year"
                />
              </v-col>
              <v-col
                cols="3"
                md="3"
                xl="2"
              >
                <v-autocomplete
                  v-model="categoryFilter"
                  clearable
                  :items="categories"
                  label="Category / Part Filter"
                  placeholder="Filter by category/year"
                />
              </v-col>

              <v-col
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-epf-dialog-copy
                  v-if="$hasPermissionTo(['copy epf'])"
                  :available-years="years"
                  @created="handleDetailCopied"
                />
              </v-col>

              <v-col
                v-if="$hasPermissionTo(['create epf'])"
                cols="12"
                md="2"
                xl="2"
              >
                <payroll-setup-epf-dialog-create
                  @created="loadEpf"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-data-table
            :headers="headers"
            :loading="tableLoading"
            :search="search"
            :items="filteredEpf"
          >
            <template v-slot:item.wages_from="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.wages_from) }}
                </span>
              </div>
            </template>

            <template v-slot:item.wages_to="{ item }">
              <div>
                <span>
                  {{ item.wages_to == '2147483647'? 'Infinity' :currencyFormatting(item.wages_to) }}  
                </span>
              </div>
            </template>

            <template v-slot:item.employee_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.employee_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.employer_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.employer_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.total_contribution="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.total_contribution) }}
                </span>
              </div>
            </template>

            <template v-slot:item.employee_default_epf_rate="{ item }">
              <div>
                <span>
                  {{ currencyFormatting(item.employee_default_epf_rate) }}
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <payroll-setup-epf-dialog-edit
                v-if="$hasPermissionTo(['update epf'])"
                :epf="item"
                @updated="loadEpf"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollSetupEpfDialogCopy: () => import('@/components/payroll/setup/epf/DialogCopy'), 
      PayrollSetupEpfDialogCreate: () => import('@/components/payroll/setup/epf/DialogCreate'),
      PayrollSetupEpfDialogEdit: () => import('@/components/payroll/setup/epf/DialogEdit'), 
      PayrollSetupEpfSettingsDialogCopy: () => import('@/components/payroll/setup/epfSettings/DialogCopy'), 
      PayrollSetupEpfSettingsDialogCreate: () => import('@/components/payroll/setup/epfSettings/DialogCreate'),
      PayrollSetupEpfSettingsDialogEdit: () => import('@/components/payroll/setup/epfSettings/DialogEdit'), 
    },
  
    data () {
      return {
        tableLoading: false,
        yearFilter: (new Date()).getFullYear(),
        categoryFilter: 'A',
        years: [],   
        categories: [],  
        search: '',
        epfs: [],
        headers: [
          {
            text: 'From (RM)',
            align: 'right',
            value: 'wages_from',
            sortable: false,
          },
          {
            text: 'To (RM)',
            align: 'right',
            value: 'wages_to',
            sortable: false,
          },
          {
            text: 'Employee Contribution (RM)',
            align: 'right',
            value: 'employee_contribution',
            sortable: false,
          },
          {
            text: 'Employer Contribution (RM)',
            align: 'right',
            value: 'employer_contribution',
            sortable: false,
          },
          {
            text: 'Total Contribution (RM)',
            align: 'right',
            value: 'total_contribution',
            sortable: false,
          },
          {
            text: 'Employee EPF Default Rate (%)',
            align: 'right',
            value: 'employee_default_epf_rate',
            sortable: false,
          },  
          {
            text: 'Category / Part',
            align: 'center',
            value: 'category',
            sortable: false,
          },  
          {
            text: '',
            value: 'action',
            align: 'center',
            sortable: false,
          },
        ],
        settingsLoading: false,
        epfSettings: [],
        settingsYears: [],   
        settingsYearFilter: (new Date()).getFullYear(),
        settingsHeaders: [
          {
            text: 'Category',
            align: 'center',
            value: 'category',
            sortable: false,
          },  
          {
            text: 'Gross (RM)',
            align: 'right',
            value: 'total_gross_without_additional_remuneration',
            sortable: false,
          },  
          {
            text: 'Gross + Additional Remuneration (RM)',
            align: 'right',
            value: 'total_gross_with_additional_remuneration',
            sortable: false,
          }, 
          {
            text: 'Employee Rate (%)',
            align: 'right',
            value: 'employee_rate',
            sortable: false,
          },
          {
            text: 'Employer Rate (%)',
            align: 'right',
            value: 'employer_rate',
            sortable: false,
          },
          {
            text: 'Description',
            align: 'left',
            width: 600,
            value: 'description',
            sortable: false,
          },
          {
            text: '',
            value: 'action',
            align: 'center',
            sortable: false,
          },
        ],
      }
    },
    computed: {
      filteredEpf () {
        return this.epfs.filter(epf => epf.year === this.yearFilter && epf.category === this.categoryFilter)
      },
      filteredEpfSetting () {
        return this.epfSettings.filter(epfSettings => epfSettings.year === this.settingsYearFilter)
      },
    },
    created () {
      this.loadEpf()
      this.loadEpfSettings()
    },  
    methods: {     
      loadEpf () {
        this.tableLoading = true

        Promise.all([
          this.$api.epf().listEpfYear(),
          this.$api.epf().listEpfCategory(),
          this.$api.epf().list(),
        ])
          .then(([year, category, epf]) => {
            this.years = year.data
            this.categories = category.data 
            this.epfs = _.orderBy(epf.data, ['employee_default_epf_rate', 'wages_from'], ['asc', 'asc'])      

            this.tableLoading = false
          })
      },

      loadEpfSettings () {
        this.settingsLoading = true

        Promise.all([
          this.$api.epfSettings().listEpfSettingsYear(),
          this.$api.epfSettings().list(),
        ])
          .then(([year, epfSettings]) => {
            this.settingsYears = year.data
            this.epfSettings = _.orderBy(epfSettings.data, ['category'], ['asc'])      

            this.settingsLoading = false
          })
      },

      decimalFormating (item) {
        return Math.round((item / 100) * 100).toFixed(2)
      },

      currencyFormatting (item) {
        let value = (this.decimalFormating(item) / 100).toFixed(2)
        return this.thousandSeparator(value)
      },

      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },

      handleDetailCopied (year) {
        this.setYearFilter(year)
        this.categoryFilter = 'A'
        this.loadEpf()
      },

      handleEpfSettingsCopied (settingsYear) {
        this.settingYearFilter = settingsYear
        this.loadEpfSettings()
      },
      setYearFilter (year) {
        this.yearFilter = year
      },    
    },
  }
</script>
